import data from '@emoji-mart/data';

type EmojiNamesDictionary = Record<string, string>;
/**
 * {
 *  '❤️': ':heart:',
 *  '💩': ':poop:',
 *  ...
 * }
 */
const EMOJI_NAMES: EmojiNamesDictionary = {};

for (const key in data.emojis) {
  const definition = data.emojis[key];
  const emoji = definition.skins[0].native;
  const formattedLabel = `:${definition.id}:`;

  EMOJI_NAMES[emoji] = formattedLabel;
}

export { EMOJI_NAMES };
